import { PaymentMethodCard } from '../types';

import { useQuery } from '@tanstack/react-query';
import { getCustomerPaymentMethods } from '../service';

const usePaymentMethods = (jwt: string) => {
  const { data, isLoading, error, refetch } = useQuery<
    PaymentMethodCard[] | undefined
  >({
    queryKey: ['paymentMethods', jwt],
    queryFn: async () => {
      try {
        const response = await getCustomerPaymentMethods(jwt);
        return response.paymentMethods ?? [];
      } catch (error) {
        console.error('Error fetching payment methods:', error);
        // Return empty array if the customer doesn't exist yet
        return [];
      }
    },
    enabled: !!jwt,
  });

  return {
    paymentMethods: data ?? [],
    isLoading: isLoading ?? true,
    hasError: !!error,
    refetch,
  };
};

export default usePaymentMethods;
